"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultisenderData = void 0;
exports.MultisenderData = {
    date: '2023-11-14T15:45:41Z',
    address: '0xD4e3D27d21D6D6d596b6524610C486F8A9c70958',
    contractName: 'Multisender',
    abi: [
        {
            anonymous: false,
            inputs: [
                {
                    indexed: true,
                    internalType: 'address',
                    name: 'previousOwner',
                    type: 'address',
                },
                {
                    indexed: true,
                    internalType: 'address',
                    name: 'newOwner',
                    type: 'address',
                },
            ],
            name: 'OwnershipTransferred',
            type: 'event',
        },
        {
            inputs: [],
            name: 'owner',
            outputs: [
                {
                    internalType: 'address',
                    name: '',
                    type: 'address',
                },
            ],
            stateMutability: 'view',
            type: 'function',
        },
        {
            inputs: [],
            name: 'renounceOwnership',
            outputs: [],
            stateMutability: 'nonpayable',
            type: 'function',
        },
        {
            inputs: [
                {
                    internalType: 'address[]',
                    name: '_recipients',
                    type: 'address[]',
                },
            ],
            name: 'sendEth',
            outputs: [],
            stateMutability: 'payable',
            type: 'function',
        },
        {
            inputs: [
                {
                    internalType: 'address[]',
                    name: '_recipients',
                    type: 'address[]',
                },
                {
                    internalType: 'address',
                    name: 'tokenContract',
                    type: 'address',
                },
            ],
            name: 'sendTokens',
            outputs: [],
            stateMutability: 'nonpayable',
            type: 'function',
        },
        {
            inputs: [
                {
                    internalType: 'address',
                    name: 'newOwner',
                    type: 'address',
                },
            ],
            name: 'transferOwnership',
            outputs: [],
            stateMutability: 'nonpayable',
            type: 'function',
        },
        {
            inputs: [],
            name: 'withdraw',
            outputs: [],
            stateMutability: 'nonpayable',
            type: 'function',
        },
        {
            inputs: [
                {
                    internalType: 'address',
                    name: 'tokenContract',
                    type: 'address',
                },
            ],
            name: 'withdrawTokens',
            outputs: [],
            stateMutability: 'nonpayable',
            type: 'function',
        },
    ],
};
//# sourceMappingURL=MultisenderData.js.map